import { Box, TextField } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { GenerateWithGPTFormType } from "./GenerateWithGPTForm";

/** Slightly stronger than default InputLabel; keeps theme label-above-field spacing. */
const fieldLabelSx = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1.4,
} as const;

interface GenerateWithGPTContentProps {
  form: UseFormReturn<GenerateWithGPTFormType>;
}

export const GenerateWithGPTContent = ({ form }: GenerateWithGPTContentProps) => {
  const {
    control,
    formState: { errors },
  } = form;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Controller
        name={"name"}
        control={control}
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            id="generate-recipe-description"
            error={Boolean(errors.name)}
            helperText={errors.name?.message ?? "Max 100 characters"}
            autoFocus={!field.value}
            label="What should we make?"
            placeholder="e.g., Vegan pesto pasta"
            multiline
            minRows={3}
            fullWidth
            inputProps={{ maxLength: 100 }}
            InputLabelProps={{ sx: fieldLabelSx }}
          />
        )}
      />
      <Controller
        name={"servingYield"}
        control={control}
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            id="generate-recipe-servings"
            value={field.value ?? ""}
            sx={{ width: "25%" }}
            error={Boolean(errors.servingYield)}
            helperText={errors.servingYield?.message}
            label="Servings"
            placeholder="#"
            type="number"
            InputLabelProps={{ sx: fieldLabelSx }}
          />
        )}
      />
    </Box>
  );
};
